import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * Fare List Container
 */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestSmartSearch = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'uiDatesYearsAdjustmentPatch',
    'airlineIataCode',
    'siteEdition',
    'page',
    'airport',
    'fullyVaccinated',
    'travelRestrictionsSource',
    'affiliateId',
    'queryFields',
    'include',
    'languagesBySiteEdition',
    'paramsTrackingExtra',
    'languageCode',
    'airlineCode',
    'tenantCode',
    'moduleId',
    'summary',
    'destinationRegion'
  ];

  // params to delete when has empty value
  const paramsEmpty = [
    'origins',
    'destinations',
    'outputCurrencies',
    'markets',
    'currencyPricingSettings',
    'travelClasses',
    'tripDuration',
    'blackoutDates',
    'budget'
  ];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  return cleanRequest;
};

export default transformRequestSmartSearch;
